// Client-side helpers for gamification display.
// Backend at /api/gamification returns { score, tier, achievements, streak_months, timeline, goals_progress }

export const TIER_META = {
  seedling: { label: "Seedling", color: "#8A8D8A", tint: "#F1EFE9" },
  sprout: { label: "Sprout", color: "#8B9D8B", tint: "#EDF2ED" },
  bronze: { label: "Bronze Builder", color: "#B87A3E", tint: "#F5EADC" },
  silver: { label: "Silver Wealth Builder", color: "#5C6E7A", tint: "#E7ECEF" },
  gold: { label: "Gold Wealth Builder", color: "#C78D4A", tint: "#F7ECD8" },
  platinum: { label: "Platinum Wealth Master", color: "#1A3626", tint: "#DEE7DF" },
};

export function tierMeta(tierKey) {
  return TIER_META[tierKey] || TIER_META.seedling;
}

// Load canvas-confetti once, cache the module.
let _confetti;
export async function fireConfetti(opts = {}) {
  if (!_confetti) {
    const mod = await import("canvas-confetti");
    _confetti = mod.default || mod;
  }
  _confetti({
    particleCount: 90,
    spread: 70,
    origin: { y: 0.6 },
    colors: ["#1A3626", "#C78D4A", "#8B9D8B", "#B87A3E", "#3A5C45"],
    ...opts,
  });
}
